import { MktPageDto } from './mkt-page.dto';
import { ApiModelProperty } from '@nestjs/swagger/dist/decorators/api-model-property.decorator';

export class MktPageCmsDto extends MktPageDto {}
